import { TerminalLink } from '@terminal-api/link-sdk'
import { ComponentProps } from 'react'

import { Button } from '@/components/ui/button'
import { TERMINAL_POST_BIND_PUBLIC_KEY, TERMINAL_PRE_BIND_PUBLIC_KEY } from '../config/config'
import { Handler } from '../lib/typeHelper'
import { useInsuranceApplicationUserId } from '../models/insuranceApplication'
import { exchangeTerminalToken, TelematicsType } from '../models/telematics'
import { useCurrentUser } from '../models/user'

interface TerminalTelematicsProps {
  handleSuccess: Handler
  buttonProps: ComponentProps<typeof Button>
  type?: TelematicsType
  /** Fires when the customer opens Terminal — `buttonProps.onClick` would replace the open itself. */
  onOpen?: () => void
  /** Replaces the customer exchange, e.g. staff linking a customer's ELD to that customer's org. */
  exchange?: (publicToken: string) => Promise<void>
  /** Overrides the id Terminal records the connection under. */
  externalId?: string
}

export function ConnectTerminalTelematics({
  handleSuccess,
  buttonProps,
  type = 'PRE_BIND',
  onOpen,
  exchange,
  externalId,
}: TerminalTelematicsProps) {
  const { user } = useCurrentUser({ enabled: false })
  const applicationUserId = useInsuranceApplicationUserId()
  const publishableKey = type === 'POST_BIND' ? TERMINAL_POST_BIND_PUBLIC_KEY : TERMINAL_PRE_BIND_PUBLIC_KEY

  function handleOpen() {
    onOpen?.()
    const link = TerminalLink.initialize({
      publishableKey,
      onSuccess: async ({ publicToken }: { publicToken: string }) => {
        if (exchange) await exchange(publicToken)
        else await exchangeTerminalToken(publicToken, type, applicationUserId)
        handleSuccess()
      },
      params: {
        externalId: externalId ?? applicationUserId ?? user?.id,
      },
    })
    link.open()
  }

  return (
    <Button
      onClick={handleOpen}
      variant="outline"
      children="Import the list from telematics"
      {...buttonProps}
    />
  )
}
